import main from '@/lib/main.js';

// 启动游戏
main();
